import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService } from '../../../../auth/auth.service';

@Component({
  selector: 'app-application-select',
  templateUrl: './application-select.component.html',
  styleUrls: ['./application-select.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ApplicationSelectComponent implements OnInit {
  

  constructor(private authService: AuthService, private route: ActivatedRoute) {
  }
  ngOnInit() {    
  }

  public get canAccessFleetManager() {
    return this.authService.canAccessFleetManager();
  }
  public get canAccessPortal() {
    return this.authService.canAccessPortal();
  }
  public get canAccessCarrier() {
    return this.authService.canAccessCarrier();
  }
  public get canAccessDeveloper() {
    return this.authService.canAccessDeveloper();
  }

  public get appCount() {
    return (this.canAccessFleetManager ? 1 : 0) +
      (this.canAccessPortal ? 1 : 0) +
      (this.canAccessCarrier ? 1 : 0) +
      (this.canAccessDeveloper ? 1 : 0);

  }
  public get showList() {    
    return this.appCount > 1;
  }

  public get applicationTitle() {
    if (this.route.snapshot.data.applicationTitle) {
      return this.route.snapshot.data.applicationTitle;
    } else if (this.appCount > 0) {
      return 'Select App'
    } 
    return 'No authorized apps found'
  };

}




// WEBPACK FOOTER //
// ./src/app/core/components/header/application-select/application-select.component.ts